import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx'
import './index.css'
import "@fontsource/caveat";

// After a new deploy, old hashed chunks 404. Reload (rate-limited) to fetch the new build.
const RELOAD_KEY = "chunk-reload-at";
const RELOAD_WINDOW_MS = 15000;

const handleChunkError = (message?: string) => {
  if (!message) return;
  const isChunkError =
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("error loading dynamically imported module") ||
    message.includes("Importing a module script failed");
  if (!isChunkError) return;
  const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
  if (Date.now() - last < RELOAD_WINDOW_MS) return;
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
};

window.addEventListener("vite:preloadError", () => handleChunkError("Failed to fetch dynamically imported module"));
window.addEventListener("error", (e) => handleChunkError(e.message));
window.addEventListener("unhandledrejection", (e) => handleChunkError(String((e.reason as Error)?.message ?? e.reason)));



createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
